import clsx from "clsx";

import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";

export type AnchorUnderlinedProps = BoxProps<"a">;

const testId = "AnchorUnderlined";
const AnchorUnderlined = (props: AnchorUnderlinedProps) => {
    const { sx, children, className, ...otherProps } = props;

    return (
        <Box
            data-testid={testId}
            className={clsx([testId, className])}
            component={"a"}
            sx={{
                textDecoration: "underline",
                cursor: "pointer",
                ...sx,
            }}
            {...otherProps}
        >
            {children}
        </Box>
    );
};

export default AnchorUnderlined;
